import { AmountType } from "./AmountType";
import { Media } from "./Media";
import { Product, ProductObject } from "./Product";
import { PurchaseRule } from "./PurchaseRule";
import { Schedule } from "./Schedule";

export interface GiftOffer extends Product {
    object: ProductObject.GIFT_OFFER;
    id: ID;
    name: string;
    price: null | number;
    desc: string;
    currency: string;
    seller: { id: ID };
    medias: Media[];
    discount?: { amount: number; amountType: AmountType };
    minimumPrice?: number;
    type: GiftOfferType;
    updateTermsRetroactively: boolean;
    photo?: { id: ID; src: string; type: string };
    system: boolean;
    baseGiftProduct: boolean;
    emailReminder: boolean;
    emailReminderDays: null | number;
    purchaseRule: PurchaseRule;
    experience?: { id: ID };
    redemptionPurchaseRule: PurchaseRule;
    couponRestrictions?: CouponRestrictions;
}

interface CouponRestrictions {
    arrivalSchedule: Schedule;
    bookBySchedule: Schedule;
}

export enum GiftOfferType {
    FIXED = "fixed",
    VARIABLE = "variable",
}
